export default "__VITE_ASSET__4553a054__"